import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LicensesPageService, UserService } from '@nrwl/common-lib';
import { get } from 'lodash';
import { ApiService } from '@nrwl/common-lib';
import { ControllerApiService } from '@nrwl/test-setup';

const settingsMock = require('./mocks/settings.json');

@Component({
  selector: 'nrwl-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, OnDestroy {
  versionNumber = '14';
  settings: any; // eslint-disable-line
  logoPath = 'images/logo_purple.svg';
  VERSION_URL = '/app-versions.json';
  isLoading = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputData: any;
  readonly unsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly apiService: ApiService,
    private readonly userService: UserService,
    private license: LicensesPageService
  ) {}

  ngOnInit() {
    if (this.userService.getThemeFromStorage() === 'dark') {
      this.logoPath = 'images/logo.svg';
    }
    this.getSoftwareVersion();
  }

  getSoftwareVersion(): void {
    this.license
      .getLicenseVersionValue$()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.versionNumber = response;
          this.getAboutSettings();
        },
        () => {
          this.getAboutSettings();
        }
      );
  }

  getAboutSettings(): void {
    this.settings = settingsMock;
    this.isLoading = false;
    this.setAboutData();
  }

  setAboutData(): void {
    this.inputData = {
      version: this.versionNumber,
      logoPath: this.logoPath,
      licenseData: get(this.settings, 'third-party-licenses', {}),
      title: 'Fusion',
      isActiveTest: this.userService.isGigatestUser ? false : true
    };
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
